import axios from "axios";
import { plainToInstance } from "class-transformer";
import { LoginStateResponse, SendOtpResponse } from "healthex-common/device-hint.dtos";
import { GenerateUserTokenResult } from "healthex-common/auth.dtos";
import { apiConfig, generateURL } from "./BaseApiService";
export class DeviceHintService {
    constructor(environment) {
        this.environment = environment;
    }
    async getLoginState() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/auth/login-state"), {
            ...apiConfig(),
            withCredentials: true,
        });
        return plainToInstance(LoginStateResponse, response.data);
    }
    async sendOtp() {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/auth/send-otp"), {}, { ...apiConfig(), withCredentials: true });
        return plainToInstance(SendOtpResponse, response.data);
    }
    async verifyOtp(input) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/auth/verify-otp"), input, {
            ...apiConfig(),
            withCredentials: true,
        });
        return plainToInstance(GenerateUserTokenResult, response.data);
    }
    async forgetDevice() {
        await axios.delete(generateURL(this.environment.API_BASE_URL, "/auth/device-hint"), {
            ...apiConfig(),
            withCredentials: true,
        });
    }
}
